import {
  // Just everything there is. Pretty WET, but I haven't managed to come up with anything better.
  extend,
  ValidationObserver,
  ValidationProvider,
  configure,
  localeChanged,
  localize,
  normalizeRules,
  setInteractionMode,
  validate,
  version,
  withValidation,
} from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

setInteractionMode('eager');

extend('required', {
  ...required,
  message: 'Обязательно',
});
extend('phone', {
  validate(value) {
    return !!value
  },
  message: 'Неверный формат',
});

export {
  extend,
  ValidationObserver,
  ValidationProvider,
  configure,
  localeChanged,
  localize,
  normalizeRules,
  setInteractionMode,
  validate,
  version,
  withValidation,
};
